import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import OfficeLayout from "@/components/OfficeLayout";
import TechLayout from "@/components/TechLayout";
import Dashboard from "@/pages/office/Dashboard";
import Schedule from "@/pages/office/Schedule";
import JobsList from "@/pages/office/JobsList";
import JobDetail from "@/pages/office/JobDetail";
import Clients from "@/pages/office/Clients";
import ClientDetail from "@/pages/office/ClientDetail";
import Invoices from "@/pages/office/Invoices";
import InvoicePrint from "@/pages/office/InvoicePrint";
import Users from "@/pages/office/Users";
import TechMyJobs from "@/pages/tech/TechMyJobs";
import TechJobDetail from "@/pages/tech/TechJobDetail";
import Guide from "@/pages/Guide";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F5F6FA]">
        <div className="text-[#6A6E85] text-sm">Loading…</div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  if (roles && !roles.includes(user.role)) {
    if (user.role === "tech") return <Navigate to="/tech" replace />;
    return <Navigate to="/" replace />;
  }
  return children;
}

function RoleHome() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return user.role === "tech" ? <Navigate to="/tech" replace /> : <Navigate to="/office" replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="bottom-right" richColors offset="16px" />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/guide" element={<Guide />} />
            <Route path="/" element={<RoleHome />} />

            {/* Office */}
            <Route
              path="/office"
              element={
                <Protected roles={["owner", "office"]}>
                  <OfficeLayout />
                </Protected>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="schedule" element={<Schedule />} />
              <Route path="jobs" element={<JobsList />} />
              <Route path="jobs/:jobId" element={<JobDetail />} />
              <Route path="clients" element={<Clients />} />
              <Route path="clients/:clientId" element={<ClientDetail />} />
              <Route path="invoices" element={<Invoices />} />
              <Route path="invoices/:invoiceId/print" element={<InvoicePrint />} />
              <Route
                path="users"
                element={
                  <Protected roles={["owner"]}>
                    <Users />
                  </Protected>
                }
              />
            </Route>

            {/* Tech */}
            <Route
              path="/tech"
              element={
                <Protected roles={["tech"]}>
                  <TechLayout />
                </Protected>
              }
            >
              <Route index element={<TechMyJobs />} />
              <Route path="jobs/:jobId" element={<TechJobDetail />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
